<!-- routes/Refer2.svelte -->
<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';

  onMount(() => {
        navigate('/');
    });
</script>